import React from 'react';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();

  const renderTranslation = (translationKey: string | undefined, interpolateObject: { [key: string]: string | undefined } | {} = {}): string | React.ReactNode | undefined => {
    if (!translationKey) return translationKey;

    let translation: string = t(translationKey, interpolateObject);

    // Allows for HTML to be used in translation files
    if (/<\/?[a-z][\s\S]*>/i.test(translation)) {
      // eslint-disable-next-line
      return React.createElement(
        'div',
        {
          // XSS attacks shouldn't be a concern just now since all our translations come from internal Json files.
          // If we move to a API translation approach maybe we should re add DOMPurify here
          dangerouslySetInnerHTML: { __html: translation }
        },
        null
      );
    }
    return translation;
  };

  return {
    t: renderTranslation
  };
};
